import { render, staticRenderFns } from "./ModalCorrectionTime.vue?vue&type=template&id=10127641"
import script from "./ModalCorrectionTime.vue?vue&type=script&lang=js"
export * from "./ModalCorrectionTime.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports